<template>
  <fragment>
    <div class="col-md-12">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="subtitle">
          Demonstrativo de Faturamento Garantia de Cheques
        </h3>
        <div class="d-flex">
          <div class="dropdown dropdownFiltroAno" v-if="anosList">
            <button
              class="btn btn-light border dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="text-muted pr-4">{{
                filtroAno ? filtroAno : "Ano"
              }}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" type="button" @click="setAno(null)">
                Todos
              </button>
              <button
                v-for="(ano, index) in anosList"
                :key="index"
                class="dropdown-item"
                type="button"
                @click="setAno(ano)"
              >
                {{ ano }}
              </button>
            </div>
          </div>
          <div class="dropdown dropdownFiltroMes ml-2" v-if="anosList">
            <button
              class="btn btn-light border dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="text-muted pr-4">{{
                filtroMes ? filtroMes : "Mês"
              }}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" type="button" @click="setMes(null)">
                Todos
              </button>
              <button
                v-for="(mes, index) in mesList"
                :key="index"
                class="dropdown-item"
                type="button"
                @click="setMes(mes)"
              >
                {{ mes }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="!loading">
      <div v-if="anosList && totalResult">
        <div
          v-for="(ano, index) in anosList"
          :key="index"
          class="mb-4 ano-list"
        >
          <div class="row" v-if="getAnoFiltro(ano)">
            <div
              class="col-md-4 col-lg-3 mt-4 mes-list"
              v-for="boleto in getPeriodosAno(ano)"
              :key="boleto.dtreffat"
              :class="{ 'd-none': !getMesFiltro(boleto.mes) }"
            >
              <RelatorioCard
                ref="relatorioCard"
                v-if="getMesFiltro(boleto.mes)"
                :mes="boleto.mes"
                :ano="boleto.ano"
                :link="{
                  name: 'demonstrativo-faturamento',
                  params: {
                    periodo: boleto.dtreffat,
                  },
                }"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="card border-0 py-5 d-flex justify-content-center align-items-center mt-4"
        >
          <h5>Nada Encontrado. 😟</h5>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <loading />
    </div>
  </fragment>
</template>

<script>
import RelatorioCard from "@/components/relatorio/RelatorioCard";

export default {
  name: "ChequeGarantido",
  data() {
    return {
      total: 0,
      periodoRelatorio: "AnoMesRelatorioCheques",
      periodos: [],
      filtroAno: null,
      filtroMes: null,
      loading: true,
      produto: {
        nome: "Relatório",
        id: "Relatorios",
      },
    };
  },
  computed: {
    totalResult() {
      return this.periodosList.filter((e) => {
        const ano = e.dtreffat.substr(0, 4);
        const mes = this.getMes(e.dtreffat.substr(5, 2));
        if (this.filtroAno && this.filtroMes) {
          if (this.filtroAno === ano && this.filtroMes === mes) {
            return true;
          } else {
            return false;
          }
        }
        if (this.filtroMes) {
          if (this.filtroMes === mes) {
            return true;
          } else {
            return false;
          }
        }
        if (this.filtroAno) {
          if (this.filtroAno === ano) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }).length;
    },
    anosList() {
      const ano = this.periodos.map((a) => a.dtreffat.substr(0, 4));
      return [...new Set(ano)];
    },
    mesList() {
      return this.$store.state.calendarOpts.pt.monthNames;
    },
    periodosList() {
      return this.periodos.map((e) => {
        const ano = e.dtreffat.substr(0, 4);
        const mes = this.getMes(e.dtreffat.substr(5, 2));
        return {
          mes: mes,
          ano: ano,
          dtreffat: e.dtreffat,
        };
      });
    },
  },
  components: {
    RelatorioCard,
  },
  methods: {
    setAno(ano) {
      this.filtroAno = ano;
    },
    setMes(mes) {
      this.filtroMes = mes;
    },
    getMesFiltro(mes) {
      if (this.filtroMes) {
        return this.filtroMes === mes ? true : false;
      }
      return true;
    },
    getAnoFiltro(ano) {
      if (this.filtroAno) {
        return this.filtroAno === ano ? true : false;
      }
      return true;
    },
    getMes(mes) {
      const m = parseInt(mes) - 1;
      return this.$store.state.calendarOpts.pt.monthNames[m];
    },
    getPeriodosAno(ano) {
      return this.periodosList.filter((a) => {
        return a.ano === ano;
      });
    },
    getPeriodos() {
      this.$http
        .get("/api/CdlBh/" + this.periodoRelatorio)
        .then((response) => {
          this.periodos = response.data.reverse();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getPeriodos();
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>
